import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './Button';
import { FlowSteps } from './FlowSteps';
import { CHECKOUT_URL } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const systemGives = ['Visual coaching progressions', 'Ready-to-use drills', 'Technical sequences', 'Reaction systems', 'Coaching cues', 'Common-error corrections', 'Decision maps', 'Controlled resistance progressions', 'Complete session structures'];
export function SystemIntro() {
  return <section className="py-24 px-4 bg-white" data-id="element-258" data-mp="1fl45avzula9e">
      <div className="max-w-5xl mx-auto" data-id="element-259" data-mp="1khcfrw33ofa8">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center max-w-3xl mx-auto" data-id="element-260" data-mp="1kkqlneaz36mf">
          <h2 className="text-3xl md:text-4xl font-black uppercase mb-6 text-zinc-950" data-id="element-261" data-mp="30v2pbicznvr9">
            From random drills to a complete MMA coaching system
          </h2>
          <p className="text-xl text-zinc-700 mb-3" data-id="element-262" data-mp="11gsfk9wyj7ug">
            MMA Coach Ready was created to give coaches structure without taking away their coaching
            judgment.
          </p>
          <p className="text-lg text-zinc-600 mb-6" data-id="element-263" data-mp="rje1ui2f4x5u">Instead of beginning every session from zero:</p>
          <FlowSteps steps={['Open', 'Choose', 'See', 'Coach']} size="lg" data-id="element-264" data-mp="mkb8huvswfdp" />
        </motion.div>

        <div className="mt-14 border-t border-zinc-200 pt-10" data-id="element-265" data-mp="hsjbp2m1xdf4">
          <h3 className="text-xl font-extrabold uppercase text-zinc-950 mb-6 text-center" data-id="element-266" data-mp="hqyltqaominl">
            The system gives you:
          </h3>
          <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3 max-w-4xl mx-auto" data-id="element-267" data-mp="8t61u8u0mmtv">
            {systemGives.map(item => <li key={item} className="flex items-start gap-3" data-id="element-268" data-mp="3sid5tt9ei2t">
                <CheckCircle2 size={18} className="text-green-600 shrink-0 mt-0.5" aria-hidden="true" data-id="element-269" data-mp="3uzbfj0zsgn8x" />
                <span className="text-zinc-700" data-id="element-270" data-mp="3laxob5g6ocin">{item}</span>
              </li>)}
          </ul>
          <p className="text-lg text-zinc-700 text-center max-w-3xl mx-auto mt-10" data-id="element-271" data-mp="3qbv5pftdd2j3">
            And because the system is designed to be 100% visual, you can understand the setup and
            progression quickly instead of reading pages of theory before teaching.
          </p>
          <p className="text-2xl font-display font-black uppercase text-violet-900 text-center mt-4" data-id="element-272" data-mp="7wswscjtmkhs">
            Open the page and use it.
          </p>
        </div>

        <div className="mt-14 bg-zinc-100 border border-zinc-200 rounded-3xl p-8 md:p-12 text-center" data-id="element-273" data-mp="3va521tqty96a">
          <h3 className="text-2xl md:text-3xl font-black uppercase text-zinc-950 mb-2" data-id="element-274" data-mp="36cjqtjwx0vy">
            Stop planning from scratch
          </h3>
          <p className="text-lg text-zinc-600 mb-8" data-id="element-275" data-mp="qv58a4y7g6gj">
            Open the system. Choose the session. Start coaching.
          </p>
          <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8" data-id="element-276" data-mp="vormi1k0oieg">
            Get MMA Coach Ready Now
          </Button>
        </div>
      </div>
    </section>;
}